import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';

import { Loader } from './shared/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FormsModule, Loader],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
